module.exports = __webpack_public_path__ + "img/resp_text_top2.8dd256e9.png";